module.exports = __webpack_public_path__ + "img/byleth-min.604ce71d.png";